<template>
    <el-dialog :visible.sync="caseModelBdialogVisible" :append-to-body="true" custom-class="container-dialog"
        title="Tips" width="700px">
        <div class="content">
            <div class="header" v-if="activedCaseDetail.typeId === 1">
                <div class="title">亲，您当前为普通用户</div>
                <div class="title">
                    该内容为 <p class="gold">年框客户</p>专享 年框用户可免费使用</div>
            </div>
            <div class="header" v-else>
                <div class="title">
                    升级<p class="gold">年框客户</p>，尊享鹿宾视觉小部件</div>
            </div>

            <div class="contrast">
                <div class="item left">
                    <p class="title">年框用户</p>
                    <div class="item-list">
                        <div class="node">
                            <div class="icon"></div>
                            <p>鹿宾殿视觉模块内容免费使用</p>
                        </div>
                        <div class="node">
                            <div class="icon"></div>
                            <p>全年整页面开发</p>
                        </div>
                        <div class="node">
                            <div class="icon"></div>
                            <p>全年动效创意设计</p>
                        </div>
                        <div class="node">
                            <div class="icon"></div>
                            <p>店铺会员中心改造</p>
                        </div>
                        <div class="node">
                            <div class="icon"></div>
                            <p>半定制化小部件、小程序换肤服务</p>
                        </div>
                        <div class="node">
                            <div class="icon"></div>
                            <p>整店首页定制开发</p>
                        </div>
                    </div>
                    <div class="button-consult-vip" @click="onConnectUpgrade">联系客服，成为年框</div>
                    <!-- 
                    <CustomerService :saveCopyType="activedCaseDetail.typeId === 1?22:30" >
                    </CustomerService> -->
                </div>
                <div class="item right">
                    <p class="title">普通用户</p>
                    <div class="item-list">
                        <div class="node">
                            <p>无专属服务团队</p>
                            <!-- <div class="icon icon-1"></div> -->
                        </div>
                        <div class="node">
                            <p>年框专属模块，需付费使用</p>
                            <!-- <div class="icon icon-2"></div> -->
                        </div>

                        <div class="node">
                            <p>原价购小部件</p>
                            <!-- <div class="icon icon-2"></div> -->
                        </div>
                        <div class="node">
                            <p>无法享受其他个性化服务</p>
                            <!-- <div class="icon icon-1"></div> -->
                        </div>
                    </div>
                    <div class="button-consult-member" @click="onConnectBuy">咨询客服单独购买</div>
                    <!-- 
                    <CustomerService :saveCopyType="activedCaseDetail.typeId === 1?24:32" >
                    </CustomerService> -->
                </div>
                <img class="center" src="../../assets/images/case/vs.png" alt="">
            </div>
            <Close :visible.sync="caseModelBdialogVisible" @onClose="onClose"></Close>
        </div>
    </el-dialog>
</template>

<script>
import { copy } from "@/utils/clipboard";
import CustomerService from '@/components/customerService'
import Close from '@/components/close'
import { saveUserBrowseData } from '@/api/common'

export default {
    components: {
        CustomerService,
        Close
    },
    props: {
        activedCaseDetail: {
            type: Object,
            default: () => { return {} },
            require: false
        },
        caseModelBdialogVisible: {
            type: Boolean,
            default: false,
            required: true,
        },
    },
    methods: {
        onClose() {
            this.$store.commit('closeOnlineConsult')
            // window.qimosdk.closeChatBox()
            this.$emit('update:caseModelBdialogVisible', false);
        },
        // 联系客服，升级年框 区分装修 小部件 记录
        onConnectUpgrade() {
            this.onConsult()
            saveUserBrowseData({
                typeId: this.activedCaseDetail.typeId === 1 ? 21 : 29,
                spmId: this.activedCaseDetail.caseId
            })
        },
        // 咨询客服单独购买
        onConnectBuy() {
            this.onConsult()
            saveUserBrowseData({
                typeId: this.activedCaseDetail.typeId === 1 ? 23 : 31,
                spmId: this.activedCaseDetail.caseId
            })
        },
        onConsult(){
            window.m7CardInfo = {
                "left": {
                    "url": this.$store.state.identity === 2 ? 'data:image/png;base64,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' : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEoAAABYCAMAAABlEJHTAAAAD1BMVEVHcExETv9ETv9EUP9ETv/uW4AzAAAABHRSTlMAfr9A+H3QJwAAApVJREFUeAGtlYuyhCAMQ03L/3/zgqC8AhRW5t6ZFe0x6QOvw6Ui1xdL4fw6iRRoLSiATCig3XDSgxws8l2TBi0UIIGM/pzTwcYrqXtklJv2OUlusiSTvc6h58SNQpKVVOXmvvJ/ruBYUKrMobQcS84fZ5Id+q6+YwWQrM3Q6akwGh0oEsZfxgbfQIVSqe9tvFFB1JX92VFBTvh/MCF5PnF32otOsKCKzpFcg1iycAs7rR4fLucXqfYBee31umo5vngCww99s2ZDFYPyNHj8Ja9bW7Kushkk1dCX1eeuyqVZlo9ILamDM2YpC4+z1JDx3YUG2A+ZZ1A1g+55Js1icRaT9IDCBcrRNh8Oz8igKEEhoDwi1NSj5Wehev3eSfOeWtO52mquNcp8LLPVHqb6lah/LHaoY1k96UuUfEayHafdUkY6cygUha/sHaEGpAMUd3eA0iFpFzUyt42agabN0L5m4m3Vov4gz2exLDhzf3dPA2rALFNlIuRU6faoTZd4F6ZD17rwp8EZ6jsStvMkodqub7C9nIvoa+UfUVIU7U9RWoX9Iwp12HWOQjO3xu4UXyW/pJzKJsw6M+R+pQJEFFZeKImi6k6XPk6YvWuZdGgfJ1ZRqBsQfZxwUdOmwpsY9BloRblJpu6ZAFEgRJT2KDQlA1Eg/Vb/jcqkNKbxWkkLt5EKTnrnnZGU+BvkSfL3Qwgpvg8GUvnVCBsyeGxKQisBRNJjei6qM6NMU/pwL0U1GoShboNYieoKTI0I9z0/mdm0R/krf0yAHqCofx3kXRb+2LaIMRWVavom5Y21QPHbH6KYwwVKBq3C9hdtNaovq+Exyn2FYnGLXA3fREb6FIX+zmEzsDFZDI6PGd5AfWs1g1sLM9QP1TQe8NTQh6oAAAAASUVORK5CYII='  // 左侧图片地址，可不填
                },
                "right1": {
                    "text": '我想咨询年框VIP服务',  // 首行文字内容，展示时超出两行隐藏，卡片上单行隐藏
                    "color": "#000",                // 字体颜色，支持十六位 #ffffff 格式的颜色，不填或错误格式默认#595959
                    "fontSize": 14                      // 字体大小， 默认12 ， 请传入number类型的数字
                },
                "right2": {

                    "text": '',        // 第二行文字内容，展示时超出两行隐藏，卡片上单行隐藏
                    "color": "#666",                 // 字体颜色，支持十六位 #ffffff 格式的颜色，不填或错误格式默认#595959
                    "fontSize": 12                      // 字体大小， 默认12 ， 请传入number类型的数字
                },
                "right3": {
                    "text": "",           // 第三行文字内容，展示时超出两行隐藏，卡片上单行隐藏
                    "color": "#ff6b6b",                 // 字体颜色，支持十六位 #ffffff 格式的颜色，不填或错误格式默认#ff6b6b
                    "fontSize": 14                      // 字体大小， 默认14 ， 请传入number类型的数字
                },
                "extraInfos": [""],             // 额外信息，访客不可见，座席点击卡片上的更多可见，可不填，字符串形式的文本数组
                "url": ''                     // 点击可跳转的链接
            }
            window.qimoChatClick()
        }
    }
}
</script>

<style lang="scss" scoped>
.content {
    background: #fff;
    width: 100%;
    // height: 738px;
    display: flex;
    flex-direction: column;
    position: relative;

    .header {
        width: 100%;
        padding: 30px 0;
        background: rgb(69, 79, 255) url('../../assets/images/case/model-header-bg.png') 0 0 no-repeat;
        background-size: cover;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .title {
            color: #fff;
            font-size: 24px;
            font-weight: 500;
            display: flex;
            letter-spacing: 2px;

            .gold {
                display: flex;
                align-items: center;
                color: rgb(222, 171, 92);
            }
        }

        .text {
            color: rgb(50, 50, 50);
            font-size: 20px;
            margin-top: 6px;
        }
    }

    .contrast {
        flex: 1;
        padding: 30px 35px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: relative;

        .center {
            position: absolute;
            width: 135px;
            height: 73px;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
        }

        .item {
            flex: 1;
            height: 460px;
            border-radius: 10px;
            padding: 35px 22px;
            font-size: 26px;
            display: flex;
            align-items: flex-start;
            flex-direction: column;
            // justify-content: space-between;

            .title {
                font-weight: 500;

            }

            .item-list {
                height: 270px;
                margin-top: 20px;

                .node {
                    display: flex;
                    align-items: center;
                    margin-bottom: 20px;
                    font-size: 16px;

                }
            }

        }

        .right {
            align-items: flex-end;
            background: rgba(240, 240, 240, .5);

            .node {
                justify-content: flex-end;
                color: rgb(91, 91, 91);


                :deep(.el-icon-error) {
                    color: rgba(0, 0, 0, 0.3);
                    font-size: 18px;
                    margin-left: 10px;
                    width: 20px;
                    height: 20px;

                }

                .icon {
                    width: 20px;
                    height: 20px;
                    border-radius: 50%;
                    margin-left: 10px;
                    /* 浅灰 */

                }

                .icon-1 {
                    background: rgba(0, 0, 0, 0.3) url('../../assets/images/case/right-icon-2.png') center center no-repeat;
                    background-size: 10px;
                }

                .icon-2 {
                    background: rgba(0, 0, 0, 0.3) url('../../assets/images/case/right-icon-1.png') center center no-repeat;
                    background-size: 9px 10px;
                }
            }

            :deep(.button-consult-member) {
                background: rgb(255, 255, 255);
                // box-shadow: 3px 4px 8px rgb(224, 185, 124);
                border: none;
                width: 250px;
                height: 50px;
                color: rgba(0, 0, 0, 0.5);
                font-size: 18px;
                border-radius: 40px;
                font-weight: 500;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;

                &:hover {
                    opacity: .8;
                }
            }
        }

        .left {
            background: url('../../assets/images/case/item-vip.png') 0 0 no-repeat;
            background-size: cover;

            .title {
                color: rgb(64, 34, 0);
            }


            :deep(.button-consult-vip) {
                background: linear-gradient(rgba(234, 188, 109, 1) 0%, rgba(244, 218, 175, 1) 100%);
                box-shadow: 3px 4px 8px rgb(224, 185, 124);
                border: none;
                width: 250px;
                height: 50px;
                color: rgb(64, 34, 0);
                font-size: 18px;
                border-radius: 40px;
                font-weight: 500;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;

                &:hover {
                    opacity: .8;
                }
            }

            .node {
                .icon {
                    width: 19px;
                    height: 19px;
                    border-radius: 50%;
                    margin-right: 10px;
                    background: rgb(64, 34, 0) url('../../assets/images/case/left-icon-1.png') center center no-repeat;
                    background-size: 12px 9px;
                }



                color: rgb(64, 34, 0);
            }
        }
    }

    .button-consult-vip {
        margin: 0 auto;
        background: linear-gradient(rgba(234, 188, 109, 1) 0%, rgba(244, 218, 175, 1) 100%);
        box-shadow: 3px 4px 8px rgb(224, 185, 124);
        border: none;
        width: 250px;
        height: 50px;
        color: rgb(64, 34, 0);
        font-size: 18px;
        border-radius: 40px;
        font-weight: 500;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        // margin-bottom: 30px;

        &:hover {
            opacity: .8;
        }
    }

    .close {
        position: absolute;
        top: 14px;
        right: 14px;
        cursor: pointer;
    }
}
</style>

<style lang="scss">
.container-case-dialog {
    border-radius: 20px !important;
    width: 709px;
    // height: 700px;
    position: relative;
    overflow: hidden;

    .el-dialog__header {
        display: none !important;
    }

    .el-dialog__body {
        padding: 0;
    }
}
</style>